import auth from '../../services/authentication';
import {useDispatch} from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import {signOut} from '../../store/searchAction';
import {useHistory} from 'react-router-dom';
import DotMenu from '../DotMenu/DotMenu';
import Avatar from '../Avatar/Avatar';
import * as Styled from './AccountInfoStyles';
import {changeDeleteModalState} from "../../store/actionCreators";

const AccountInfo = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const handleSignOut = () => {
    dispatch(signOut());
    history.push('/');
  }

  const handleDelete = () => {
    dispatch(changeDeleteModalState());
  }
  const menuOptions = [{
    label: 'Sign Out',
    action: handleSignOut,
  }, {
    label: 'Delete Account',
    labelType: 'error',
    action: handleDelete,
  }];
  const username = `${auth.getUserName()}`;

  return (
    <Styled.InfoContainer className='AccountInfoBlock' fluid="xl">
      <Row className="align-items-center justify-content-start">
        <Col sm={2} className="d-none d-sm-block">
          <Avatar largeImg={' LargeImg'} />
        </Col>
        <Col xs={6} sm={3}>
          <Styled.StyledH2 className='FullNameInfo'>
            {username}
          </Styled.StyledH2>
          <Styled.StyledBtn variant='link' className='EmailBtn'>
            {auth.getEmail() || ''}
          </Styled.StyledBtn>
        </Col>
        <Col xs={{ span: 1, offset: 4 }} sm={{ span: 1, offset: 6 }} className="text-md-right">
          <DotMenu options={menuOptions} visible />
        </Col>
      </Row>
    </Styled.InfoContainer>
  );
}

export default AccountInfo;